import { DRAWER_WIDTH } from '../Settings'
import { Skeleton } from '@dashboard/ui'

export default function DrawerSkeleton() {
  return (
    <div
      className="box-border flex flex-col rounded-none px-1"
      style={{
        width: DRAWER_WIDTH,
      }}
    >
      <div className="my-3 flex h-8 items-center px-2">
        <Skeleton className="size-9 rounded-full" />
        <Skeleton className="ml-2 h-[40px] w-[183px] rounded-md" />
      </div>

      <div className="mb-2 flex flex-col gap-1 px-2 py-0">
        {Array(8)
          .fill('')
          .map((_, idx) => (
            <Skeleton key={`drawer-menu-item-${idx}`} className="h-6 rounded-md" />
          ))}

        <Skeleton className="mt-3 h-9 rounded-md" />
      </div>
    </div>
  )
}
